import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'
import '../app.css'
import App from '../App.vue'
import shapeArchitect3dRoutes from '../router/routes/shape-architect-3d'
import { initSentry } from '../lib/sentry'

// Branding
document.title = 'ShapeArchitect3D | Codifyo'
const faviconLink = document.getElementById('favicon-link')
if (faviconLink) {
    faviconLink.setAttribute('href', '/favicon-3d.png')
}

const router = createRouter({
    history: createWebHistory(),
    routes: shapeArchitect3dRoutes,
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth) && !localStorage.getItem('apiToken')) {
        next({ name: 'shape_architect_3d_login' })
    } else {
        next()
    }
})

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
initSentry(app, router)
app.mount('#app')
